import {Link} from "react-router-dom";
import React from "react";
import {ShortcutContainer} from "./styles";
import {useLocation} from "react-router";
import {useUser} from "../../store/providers/app";

export const Shortcuts = () => {
    const { user } = useUser()
    const path = useLocation()
    const location = path.pathname.split('/')

    return (
        <>
            { user.profile === 1 && (

                <ShortcutContainer>
                    <span className="fw-bolder fs-5">Atalhos</span>

                    <div className="d-flex gap-2 mt-3">
                        <Link to="/collect/indicator/add" className="shortcut-link">
                            <i className="bi bi-file-earmark-plus fs-2 text-info"/>
                            <span>Criar indicador</span>
                        </Link>
                        <Link to="/documents" className="shortcut-link">
                            <i className="bi bi-cloud-arrow-up fs-2 text-success"/>
                            <span>Enviar documentos</span>
                        </Link>
                        {location[2] === 'indicators' ? (
                            <Link to="/dashboard/goals" className="shortcut-link">
                                <i className="bi  bi-grid fs-2 text-warning"/>
                                <span>Painel de metas</span>
                            </Link>
                        ) : (
                            <Link to="/dashboard/indicators" className="shortcut-link">
                                <i className="bi  bi-grid fs-2 text-warning"/>
                                <span>Painel de indicadores</span>
                            </Link>
                        )}

                    </div>
                </ShortcutContainer>
            )}

        </>

    )
}
